<template>
  <div class="right-listt">
    <!-- 五个按钮 -->
    <div
      class="cola-list-new"
      v-for="(item, i) in list"
      :key="i"
      @click="listcloa(i)"
      @mouseover="touch(i)"
      @mouseleave="touch1()"
    >
      <div>
        <span :class="L == i ? 'span1' : 'span'">{{ item.name }}</span>
      </div>
      <div>
        <img :src="item.imaeg" />
      </div>
    </div>
    <!-- 迅游 -->
    <div class="roam">
      <div :class="l == 3 ? 'roam-now1' : 'roam-now'">
        <span :style="{ color: setat == 1 ? '#fff' : '' }" @click="pipeline(1)">通风线路</span>
        <span :style="{ color: setat == 2 ? '#fff' : '' }" @click="pipeline(2)">煤巷游览</span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      l: null,
      L: null,
      setat: 0,
      list: [
        { name: "水晶模式", imaeg: require("../../assets/sjms.png") },
        { name: "实景渲染", imaeg: require("../../assets/sjxr.png") },
        { name: "整体视角", imaeg: require("../../assets/ztsj.png") },
        { name: "自动漫游", imaeg: require("../../assets/zdmy.png") },
        { name: "手动漫游", imaeg: require("../../assets/sdmy.png") },
      ],
      a: true,
    };
  },
  methods: {
    listcloa(a) {
      this.setat = 0;
      if (this.l == a) {
        this.l = 100;
        return;
      }
      this.l = a;
    },
    pipeline(i) {
      this.setat = i;
    },
    touch(i) {
      this.L = i;
      this.l = i;
      this.a = false;
    },
    touch1() {
      if (this.a) {
        this.L = 100;
        this.l = 100;
      }
    },
  },
};
</script>
<style lang="less" scoped>
.right-listt {
  width: 10%;
  height: 30%;
  position: absolute;
  right: 20%;
  bottom: 50%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  .cola-list-new {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-around;
    & > div:first-child {
      width: 70%;
      text-align: center;
    }
    .span {
      font-size: 0.8vw;
      color: #fff;
      font-weight: 400;
      transition: all 0.5s;
      opacity: 0;
    }
    .span1 {
      font-size: 0.8vw;
      color: #fff;
      font-weight: 400;
      transition: all 0.5s;
      opacity: 100;
    }
    & > div:last-child {
      width: 30%;
      height: 100%;
      img {
        width: 50%;
        height: auto;
        cursor: pointer;
      }
    }
  }
}
.roam {
  position: absolute;
  right: 85%;
  top: 68.3%;
  padding: 0.2vh 0.5vw;
  overflow: hidden;
  // border: 1px solid red;
  .roam-now {
    transform: translateX(110%);
    transition: all 0.5s;
    white-space: nowrap;
    background-image: linear-gradient(
      to left,
      rgba(1, 78, 147, 1),
      rgba(1, 78, 147, 0.1)
    );
  }
  span {
    font-size: 0.8vw;
    margin: 0 0.5vw;
    cursor: pointer;
    color: #fff;
    transition: all 1s;
  }
  span:hover {
    color: #fff;
  }
}
.roam-now1 {
  transform: translateX(0%);
  transition: all 0.5s;
  white-space: nowrap;
  background-image: linear-gradient(
    to left,
    rgba(1, 78, 147, 1),
    rgba(1, 78, 147, 0.1)
  );
}
</style>
